<template>
  <sui-form-field>
    <div class="ui fluid button" data-goal="CREATE_PROVIDER_OAUTH" @click.prevent="openProviderConnector()">
      Connect with OAuth...
    </div>
    <small class="success" v-show="connected">
      Authorization completed
    </small>
  </sui-form-field>
</template>

<script>
  export default {
    name: 'FormProviderConnect',
    data() {
      return {
        connected: false,
      }
    },
    computed: {
      entity() {
        return this.$parent.entity || this.$parent.$parent.entity
      },
    },
    methods: {
      onMessage(event) {
        const {name, data} = event.data || {}
        if (name === 'oauthToken') {
          const auth = {}
          this.connected = true
          if (data.accessToken) {
            auth.apiToken = data.accessToken
          }
          if (data.refreshToken) {
            auth.refreshToken = data.refreshToken
          }
          if (data.drives) {
            this.$parent.drives = data.drives
          }
          this.entity.auth = auth
        }
      },
      openProviderConnector() {
        this.entity.oauth()
      },
    },
    mounted() {
      window.addEventListener('message', this.onMessage)
    },
    beforeDestroy() {
      window.removeEventListener('message', this.onMessage)
    },
  }
</script>

<style scoped>
  .success { color: #3a9f38; }
</style>
